import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { Logo } from './Logo';

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBuscarMedicos = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.getElementById('busca');
      if (el) { el.scrollIntoView({ behavior: 'smooth' }); return; }
    }
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('busca');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      else window.scrollTo(0, 0);
    }, 300);
  };

  const scrollTop = () => window.scrollTo(0, 0);
  return (
    <footer className="bg-[#1A2421] text-white" data-testid="footer">
      <div className="container-app py-10 md:py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="space-y-4 col-span-2 lg:col-span-1">
            <Logo size="md" variant="on-dark" />
            <p className="text-white/50 leading-relaxed text-sm">
              Sua saúde em primeiro lugar. Encontre o médico ideal e agende sua consulta em minutos.
            </p>
            <div className="flex gap-2.5">
              <a href="#" className="w-9 h-9 bg-white/8 rounded-xl flex items-center justify-center hover:bg-primary transition-colors" aria-label="Facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/8 rounded-xl flex items-center justify-center hover:bg-primary transition-colors" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/8 rounded-xl flex items-center justify-center hover:bg-primary transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-sm mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Para Pacientes</h4>
            <ul className="space-y-3">
              <li>
                <a href="/#busca" onClick={handleBuscarMedicos} className="text-white/50 hover:text-white transition-colors text-sm">
                  Buscar Médicos
                </a>
              </li>
            </ul>
          </div>

          {/* For Providers */}
          <div>
            <h4 className="font-semibold text-sm mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Para Pessoa Jurídica</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/cadastro?type=provider" onClick={scrollTop} className="text-white/50 hover:text-white transition-colors text-sm">
                  Cadastrar ou Atualizar CNPJ
                </Link>
              </li>
              <li>
                <Link to="/login" onClick={scrollTop} className="text-white/50 hover:text-white transition-colors text-sm">
                  Área do Prestador
                </Link>
              </li>
              <li>
                <Link to="/como-funciona-pj" onClick={scrollTop} className="text-white/50 hover:text-white transition-colors text-sm">
                  Como Funciona
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-semibold text-sm mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Sobre Nós</h4>
            <p className="text-white/50 text-sm leading-relaxed mb-3">
              O BuscaDoutor conecta pacientes a profissionais de saúde com o cuidado certo, em qualquer lugar do Brasil.
            </p>
            <ul className="space-y-3 mt-2">
              <li>
                <Link
                  to="/sobre"
                  onClick={scrollTop}
                  className="text-amber-400 hover:text-amber-300 transition-colors text-sm inline-flex items-center gap-1"
                  data-testid="footer-about-link"
                >
                  Saiba mais →
                </Link>
              </li>
              <li>
                <Link
                  to="/seguranca"
                  onClick={scrollTop}
                  className="text-white/50 hover:text-white transition-colors text-sm"
                  data-testid="footer-compliance-link"
                >
                  Segurança ou Compliance
                </Link>
              </li>
              <li>
                <Link
                  to="/termos"
                  onClick={scrollTop}
                  className="text-white/50 hover:text-white transition-colors text-sm"
                  data-testid="footer-terms-link"
                >
                  Termos de Uso
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/50 text-sm">
                <Mail className="w-4 h-4 text-primary flex-shrink-0" />
                <span>support@buscadoutor.com.br</span>
              </li>
              <li className="flex items-start gap-3 text-white/50 text-sm">
                <MapPin className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                <span>Sao Paulo, SP - Brasil</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 text-center">
          <p className="text-white/30 text-xs">
            &copy; 2025 BuscaDoutor. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
